export default __webpack_public_path__ + "static/media/icon_download.87e4215d.svg";